import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MODAL_TOKEN, ModalProvider } from '@core';

@Component({
  selector: 'lib-push-collect-points',
  templateUrl: './push-collect-points.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushCollectPointsComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
